/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: b6710d7af609
 */

import * as z from "zod";
import { triggersTestTrigger } from "../../funcs/triggersTestTrigger.js";
import { TestTriggerRequest$zodSchema } from "../../models/testtriggerrequest.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  id: z.string().describe("The ID of the trigger to test."),
  test_trigger_request: TestTriggerRequest$zodSchema.optional().describe(
    `The test data for the trigger.`,
  ),
};

export const tool$triggersTestTrigger: ToolDefinition<typeof args> = {
  name: "test-trigger",
  description: `Tests an existing trigger's filter against sample data

Evaluates an existing trigger's filter against provided sample data.
Use this endpoint to verify that a trigger's filter will match expected events.
`,
  scopes: ["admin"],
  annotations: {
    "title": "Test Trigger Filter",
    "destructiveHint": false,
    "idempotentHint": true,
    "openWorldHint": false,
    "readOnlyHint": true,
  },
  args,
  tool: async (client, args, ctx) => {
    const [result] = await triggersTestTrigger(
      client,
      args.id,
      args.test_trigger_request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
